import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import { normalizeTimeZoneId, parseDateTimeInTimezone } from './timezone.service';

dayjs.extend(utc);
dayjs.extend(advancedFormat);
dayjs.extend(timezone);

export function capitalize(value: string) {
  return value
    .split(' ')
    .map((val) => val.charAt(0).toUpperCase() + val.substr(1).toLowerCase())
    .join(' ');
}

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

/**
 * TODO: This needs to replace format money.
 */
export function formatMoneyV2(value: number | bigint): string {
  return USDollar.format(value);
}

export function formatMoney(value: number) {
  return `$${value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
}

export function formatDate(value: string) {
  return dayjs(value).format('MMMM D, YYYY');
}

export function formatShortDate(value: string) {
  return dayjs(value).format('MM/DD/YYYY');
}

export function formatUTCShortDate(value: string | Date) {
  return formatUTC(value);
}

export function formatUTC(value: string | Date, format = 'MM/DD/YYYY') {
  return dayjs.utc(value).format(format);
}

export function formatShortDateTime(value: string) {
  return dayjs(value).format('MM/DD/YYYY hh:mma');
}

export function formatDateTimeWithTimezone(value: string, tz: string) {
  if (!value) return '';
  const parsed = parseDateTimeInTimezone(value, tz);
  if (!parsed.isValid()) return '';
  return parsed.format('MMM D, YYYY h:mm A z');
}

export function formatDateTimeFromUtcWithTimezone(value: string, tz: string) {
  if (!value) return '';
  const parsed = dayjs.utc(value);
  if (!parsed.isValid()) return '';
  const timeZone = normalizeTimeZoneId(tz);
  return parsed.tz(timeZone).format('MMM D, YYYY h:mm A z');
}

export function formatShortDateWithTimezone(value: string, tz: string) {
  if (!value) return '';
  const parsed = parseDateTimeInTimezone(value, tz);
  if (!parsed.isValid()) return '';
  return parsed.format('MM/DD/YYYY z');
}
